module.exports = __webpack_public_path__ + "static/media/PD-mock.6df86695.png";